import { render } from "./Feedback.vue?vue&type=template&id=3a391bf8&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=3a391bf8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\ArbeitFinderundBeraterVersionen\\MonitorBerater\\MonitorweltBerater\\FindingoBerater\\BeforeWordpressBerater_new_WordpressProduction\\newDataForm\\newDataForm\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a391bf8"]])

export default __exports__